<template>
  <Skeleton active :loading="skeletonLoading">
    <Spin :spinning="loading">
      <div class="list">
        <slot>
          <div class="item" v-for="item in dataList">
            <div class="info">
              <div class="title" :title="item.title" @click.stop="onClick(item)">{{ item.title }}</div>
              <div class="text" @click="onClick(item)">{{ getHTMLText(item.content) }}</div>
            </div>
            <div class="tag" @click.stop="onClickTag(item)">相关新闻</div>
          </div>
          <Empty v-if="dataList.length === 0" />
        </slot>
      </div>
    </Spin>
  </Skeleton>
</template>
<script setup lang="ts">
import { watch } from 'vue'
import { Skeleton, Spin, Empty } from 'ant-design-vue'
import useList from '@/hooks/useList'
import { getNoticeList } from '@/api/notice'
import routerByNoticeTag from '@/utils/noticeTag'
import { toDetail } from '@/utils'
import useInit from '@/hooks/useInit'
import { getHTMLText } from '@/utils/index'

type Props = {
  /** 显示顶部的分页器 */
  showTopPagination?: boolean
  /** 列表所查询的`noticeTag` */
  noticeTags: string
}

const props = withDefaults(defineProps<Props>(), {
  showTopPagination: true,
})

const { dataList, loading, pagination, onQueryList } = useList<NoticeItem>({
  getList: getNoticeList,
  formatGetListQuery(query) {
    return {
      ...query,
      noticeTags: props.noticeTags,
      /** 排序方式 1 创建时间 2 发布时间倒序 3 浏览量 4 发布时间正序 */
      sortBy: 2,
    }
  },
})

const { loading: skeletonLoading } = useInit(dataList)

watch(
  () => [pagination.current, pagination.pageSize],
  () => {
    onQueryList()
  }
)

function onClickTag(item: NoticeItem) {
  // routerByNoticeTag(item.noticeTag)
  window.open(`/#/searchPage/index?value=${item.title.replace(/\w/g, '')}`, '_blank')
}

function onClick(item: NoticeItem) {
  toDetail(item)
}
</script>
<style lang="less" scoped>
.list {
  .item {
    display: flex;
    margin-bottom: 16px;
    .info {
      flex: 1;
      .title {
        font-size: 15px;
        color: black;
        cursor: pointer;
      }
      .text {
        color: #646464;
        font-size: 12px;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .tag {
      margin-left: 100px;
      background: @primary;
      border-radius: 15px;
      display: inline-block;
      color: #fff;
      padding: 0 13px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      font-size: 12px;
      transition: all 0.2s;
      &:hover {
        background: @success;
      }
    }
  }
}
</style>
